module.exports = __webpack_public_path__ + "static/media/marker.72e14251.png";